import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import ILoading from '../../../app/_interfaces/ILoading';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading: ILoading = {
    isLoading: false,
    message: '',
  };
  private loading$: Subject<ILoading>;
  constructor() {
    this.loading$ = new Subject();
  }

  isLoading$() {
    return this.loading$;
  }

  setLoading(payload: ILoading) {
    this.loading = payload;
    return this.loading$.next(this.loading);
  }

  stopLoading() {
    this.loading = undefined;
    return this.loading$.next(this.loading);
  }

  isLoading() {
    return this.loading;
  }
}
